<template>
  <div>
    <VDropdown theme="ghost" placement="bottom-end">
      <BaseButton primary type="button">
        <span class="inline-flex"> Add </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4 inline-flex ml-2"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="12" r="1" />
          <circle cx="12" cy="19" r="1" />
          <circle cx="12" cy="5" r="1" />
        </svg>
      </BaseButton>
      <template #popper>
        <div
          class="w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div class="py-1">
            <button
              v-if="$membershipHasPermissionTo('create sms integrations')"
              type="button"
              class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              role="menuitem"
              v-close-popper
              @click="showModal('vonage', 'sms')"
            >
              Nexmo SMS
            </button>
            <AddCustomEmail
              v-if="$membershipHasPermissionTo('create email integrations')"
              :account-id="accountId"
            />
            <AddWoocommerceApiService
              v-if="$membershipHasPermissionTo('create woocommerce integrations')"
              :account-id="accountId"
            />
            <AddSoftOneApiService
              v-if="$membershipHasPermissionTo('create softone integrations')"
              :account-id="accountId"
            />
            <RouterLink
              v-if="$membershipHasPermissionTo('create facebook integrations')"
              :to="{
                name: 'accounts.accountId.settings.integrations.facebook',
                params: {
                  accountId,
                },
              }"
              class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              role="menuitem"
              v-close-popper
            >
              Facebook
            </RouterLink>
          </div>
        </div>
      </template>
    </VDropdown>

    <Portal to="app-dialog" v-if="show">
      <ThirdPartyServiceCreateModal
        :account-id="accountId"
        :service="service"
        :channel="channel"
        @hide="hideModal"
      />
    </Portal>
  </div>
</template>

<script>
import ThirdPartyServiceCreateModal from './ThirdPartyServiceCreateModal.vue';
import AddWoocommerceApiService from './AddWoocommerceApiService.vue';
import AddSoftOneApiService from './AddSoftOneApiService.vue';
import AddCustomEmail from './AddCustomEmail.vue';

export default {
  components: {
    ThirdPartyServiceCreateModal,
    AddWoocommerceApiService,
    AddSoftOneApiService,
    AddCustomEmail,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      service: null,
      channel: null,
      show: false,
    };
  },
  methods: {
    setShow(value) {
      this.show = Boolean(value);
    },
    showModal(service, channel) {
      this.service = service;
      this.channel = channel;
      this.setShow(true);
    },
    hideModal() {
      this.setShow(false);
      this.service = null;
      this.channel = null;
    },
  },
};
</script>
